import script from "./base-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-header.vue?vue&type=script&setup=true&lang=ts"

import "./base-header.vue?vue&type=style&index=0&id=05367098&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05367098"]])

export default __exports__